import { useTranslation } from "react-i18next";
import { setLang } from "@/i18n";
import { Globe } from "@phosphor-icons/react";

export function LanguageSwitcher({ className = "", dark = true }) {
  const { i18n } = useTranslation();
  const lng = (i18n.resolvedLanguage || i18n.language || "en").slice(0, 2);
  const base = dark ? "bg-black/40 border-white/15 text-neutral-200 hover:bg-black/60" : "bg-white/70 border-black/10 text-neutral-800 hover:bg-white";
  return (
    <div className={`inline-flex items-center gap-1 rounded-full border px-1 py-1 backdrop-blur ${base} ${className}`} data-testid="language-switcher">
      <Globe size={14} className="ml-1.5 opacity-60" />
      <button onClick={() => setLang("en")} data-testid="lang-en"
        className={`text-xs font-semibold rounded-full px-2 py-0.5 ${lng === "en" ? "bg-gold text-obsidian" : "opacity-70"}`}>EN</button>
      <button onClick={() => setLang("es")} data-testid="lang-es"
        className={`text-xs font-semibold rounded-full px-2 py-0.5 ${lng === "es" ? "bg-gold text-obsidian" : "opacity-70"}`}>ES</button>
    </div>
  );
}

export default LanguageSwitcher;
